import { render, staticRenderFns } from "./RecentlyViewed.vue?vue&type=template&id=a7ef3e4a"
import script from "./RecentlyViewed.vue?vue&type=script&lang=js"
export * from "./RecentlyViewed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports